import { render, staticRenderFns } from "./Components1.vue?vue&type=template&id=f04abeda&scoped=true"
import script from "./Components1.vue?vue&type=script&lang=js"
export * from "./Components1.vue?vue&type=script&lang=js"
import style0 from "./Components1.vue?vue&type=style&index=0&id=f04abeda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04abeda",
  null
  
)

export default component.exports